import {MULTIPLE_CHOICE_ELEMENT_FRAGMENT} from "./wissenwirkt-multiplechoice-element-display.graphql";
import {useFragment} from "react-relay";
import {WissenwirktMultiplechoiceElementDisplayProps} from "./wissenwirkt-multiplechoice-element-display.types";
import {
    AnswerContainer, AnswerDiv,
    AnswersWrapper, AnswerText, ImageStyle,
    PageTitle,
    TextQuestion
} from "./wissenwirkt-multiplechoice-element-display.styles";
import {
    wissenwirktMultiplechoiceElementDisplay_MultipleChoiceElementV2Fragment$key
} from "../../../../__generated__/wissenwirktMultiplechoiceElementDisplay_MultipleChoiceElementV2Fragment.graphql";


export interface MultipleChoiceState {
    checkedAnswerIndices: number[];
}

const ASCII = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";



export function WissenwirktMultipleChoiceElementDisplay({
	checkedAnswerIndices,
	setCheckedAnswerIndices,
	multipleChoiceElementFragmentRef,
	currentElementIndex,
	className,
}: WissenwirktMultiplechoiceElementDisplayProps) {
	const multipleChoiceElement =
		useFragment<wissenwirktMultiplechoiceElementDisplay_MultipleChoiceElementV2Fragment$key>(
			MULTIPLE_CHOICE_ELEMENT_FRAGMENT,
			multipleChoiceElementFragmentRef,
		);

	if (!multipleChoiceElement) return null;

	const isLastQuestion = multipleChoiceElement.answerOptions.length;

	const toggleAnswer = (index: number) => {
		const newIndices =
			multipleChoiceElement.answeringType === "allowOnlyOneAnswer"
				? []
				: checkedAnswerIndices.filter((x) => x !== index);
		setCheckedAnswerIndices([
			...newIndices,
			...(checkedAnswerIndices.includes(index) ? [] : [index]),
		]);
	};

	return (
		<div className="px-5 pt-5 flex flex-column justify-content-center">
			<PageTitle className="text-center"> Lernerfolgskontrolle</PageTitle>
			<TextQuestion
				dangerouslySetInnerHTML={{
					__html: `${currentElementIndex + 1}. Frage: ${multipleChoiceElement.question}`,
				}}
				className={`font-bold pb-4 lg:text-xl ${className}`}
			/>
			{multipleChoiceElement.image?.url && (
				<ImageStyle className="mb-5" src={multipleChoiceElement.image.url} alt="" />
			)}
			<AnswersWrapper>
				<AnswerContainer>
					{multipleChoiceElement.answerOptions?.map((ao, index) => (
						<div
							key={`answerOption-${index}`}
							className="cursor-pointer"
							onClick={() => {
								toggleAnswer(index);
							}}
						>
							<AnswerDiv
								key={ao.answer + index}
								className={`${
    checkedAnswerIndices.includes(index)
        ? "bg-primary border-primary"
        : "border-black-alpha-90"
} ${isLastQuestion == index + 1 ? "mb-0" : "mb-2"} p-2 lg:p-4`}
							>
								<div className="flex align-items-center">
									<div className="pl-2 pr-3 md:pl-3 md:pr-5 font-bold flex align-items-center text-lg ">
										{ASCII[index]}
									</div>
									<AnswerText
										className="flex-grow-1 flex flex-column align-items-start text-sm md:text-base"
										dangerouslySetInnerHTML={{ __html: ao.answer }}
									/>
								</div>
								{ao.image?.url && <ImageStyle className="ml-3 mt-3" src={ao.image.url} alt="" />}
							</AnswerDiv>
						</div>
					))}
				</AnswerContainer>
			</AnswersWrapper>
		</div>
	);
}

